import React from 'react';
import { Heart } from 'lucide-react';
import { useWishlist } from '../hooks/useWishlist';

/**
 * Floating heart toggle for tour cards / tour hero.
 * Uses localStorage via useWishlist. `variant`:
 *   - "card": tiny circle (top-right of tour card)
 *   - "hero": bigger transparent button (tour detail hero)
 *   - "inline": text-labeled (used on shortlist page)
 */
const WishlistButton = ({ tourId, tourTitle, variant = 'card', onClick }) => {
  const { has, toggle } = useWishlist();
  const active = has(tourId);

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggle(tourId);
    onClick?.(!active);
  };

  const label = active ? 'Beğenilenlerden kaldır' : 'Beğenilenlere ekle';

  if (variant === 'hero') {
    return (
      <button
        onClick={handleClick}
        aria-pressed={active}
        aria-label={label}
        title={label}
        data-testid={`wishlist-hero-${tourId}`}
        className="bg-white/20 backdrop-blur-sm text-white rounded-full p-2.5 hover:bg-white/30 transition-colors"
      >
        <Heart size={18} fill={active ? '#ef4444' : 'transparent'} stroke={active ? '#ef4444' : 'currentColor'} />
      </button>
    );
  }

  if (variant === 'inline') {
    return (
      <button
        onClick={handleClick}
        aria-pressed={active}
        data-testid={`wishlist-inline-${tourId}`}
        className="inline-flex items-center gap-1.5 text-xs font-semibold text-red-500 hover:text-red-700"
      >
        <Heart size={14} fill="#ef4444" /> Kaldır
      </button>
    );
  }

  return (
    <button
      onClick={handleClick}
      aria-pressed={active}
      aria-label={label}
      title={label}
      data-testid={`wishlist-card-${tourId}`}
      className="absolute top-2.5 right-2.5 z-10 w-8 h-8 rounded-full bg-white/90 backdrop-blur shadow-sm flex items-center justify-center hover:bg-white transition-all duration-200 hover:scale-110"
    >
      <Heart size={15} fill={active ? '#ef4444' : 'transparent'} stroke={active ? '#ef4444' : '#1B1B1B'} strokeWidth={active ? 2 : 1.6} />
    </button>
  );
};

export default WishlistButton;
